import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
var STYLE_CACHE = [];

var StyledComponent = function StyledComponent(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      theme = _ref.theme;
  return children(classes, theme);
};
/**
 * @param {import('./types').StyledProps} props
 */


var Styled = function Styled(_ref2) {
  var styles = _ref2.styles,
      theme = _ref2.theme,
      name = _ref2.name,
      props = _objectWithoutProperties(_ref2, ["styles", "theme", "name"]);

  var styleSheet = STYLE_CACHE.find(function (s) {
    return s.styles === styles;
  });

  if (!styleSheet) {
    styleSheet = {
      styles: styles,
      component: withStyles(styles, {
        withTheme: theme,
        name: name
      })(StyledComponent)
    };
    STYLE_CACHE.push(styleSheet);
  }

  return React.createElement(styleSheet.component, props);
};

Styled.defaultProps = {
  theme: false
};
export default Styled;